import { render, staticRenderFns } from "./text-p.vue?vue&type=template&id=66e5d5b2"
import script from "./text-p.vue?vue&type=script&lang=js"
export * from "./text-p.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports